function toggleAccordion() {
	$(".accordionCard__title").click(function(e) {
		e.preventDefault();
		var $this = $(this);
		if ($this.next().hasClass("show")) {
			$this
				.next()
				.removeClass("show")
				.fadeOut(0);
			$this.parent().removeClass("active");
		} else {
			$this
				.parent()
				.parent()
				.find(".accordionCard__inner")
				.removeClass("show");
			$this
				.parent()
				.parent()
				.find(".accordionCard")
				.removeClass("active");
			$this
				.parent()
				.parent()
				.find(".accordionCard__inner")
				.fadeOut(0);
			$this
				.next()
				.toggleClass("show")
				.fadeToggle(350);
			$this.parent().toggleClass("active");
		}
	});
	// $('.accordionCard:first-child .accordionCard__title').click();
}